import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            动漫世界每日新鲜事，一站掌握
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          {/* Timeline line */}
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="flex flex-col gap-5">
            {updatesData.map((item) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14">
                {/* Timeline dot */}
                <div className="absolute left-2 md:left-4 top-1.5 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100 flex-shrink-0"></div>

                {/* Date */}
                <div className="w-12 md:w-14 flex-shrink-0">
                  <span className="text-xs font-semibold text-accent-600 bg-accent-100 px-2 py-1 rounded-md whitespace-nowrap">
                    {item.date}
                  </span>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <h3 className="text-sm md:text-base font-medium text-foreground-900">
                      {item.title}
                    </h3>
                    <span className="text-xs text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap font-medium">
                      {item.tag}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}